import { Fragment, h } from "preact";
import { memo } from "react";
import { compareRender } from "../../../functions/form";
import { useController, UseControllerProps } from "react-hook-form";
import { DatePicker as DatePickerAntd } from "antd";
import { TextXSMall } from "../../text";
import { ContainerNoText } from "./styled";
import { RowComponent } from "../../../style/styled";

interface IProperties {
  showTime?: boolean;
  picker?: "date" | "week" | "month" | "quarter" | "year";
}

interface IItem extends UseControllerProps {
  ref: string;
  id: string;
  format?: string;
  label?: string;
  placeholder?: string;
  span?: number;
  disabled?: boolean;
  properties: IProperties;
  onEnter?(i: string, force: boolean): Promise<void>;
}

interface IDatePicker {
  control?: any;
  item: IItem;
  handleChange?: any;
}

const DatePicker = ({ control, item, handleChange }: IDatePicker) => {
  const {
    ref,
    rules,
    name,
    defaultValue,
    label,
    placeholder,
    disabled,
    properties,
    format,
  } = item;
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  });
  const { error } = fieldState;
  const { value } = field;

  return (
    <>
      <RowComponent>
        {label !== "" ? (
          <TextXSMall text={label} bold={true} />
        ) : (
          <ContainerNoText></ContainerNoText>
        )}
        {error && <div />}
      </RowComponent>
      {/* @ts-ignore - React/Preact type incompatibility */}
      <DatePickerAntd
        id={ref}
        name={ref}
        value={value}
        disabled={disabled}
        onChange={(e) => handleChange(e, item)}
        placeholder={placeholder}
        autoComplete={"off"}
        showTime={properties?.showTime}
        picker={properties?.picker}
        format={format}
      />
    </>
  );
};

export const MemoizedDatePicker = memo(
  DatePicker,
  (prev, next) =>
    compareRender(prev, next) &&
    compareRender(prev.item, next.item, "disabled") &&
    compareRender(prev.item, next.item, "placeholder")
);
